import { colors } from "@/shared/tokens/colors";

const word2tokenStyle = { fontWeight: 'bold' }
export const modelsData = [
    {
        key: 0,
        model: 'Llama 3 8B - Instruct',
        knowledge_cutoff: "2023-02-06-08:27:12",
        context_size: '8192',
        word2token: <div style={{ ...word2tokenStyle, color: colors.red }}>1:3</div>,
        isInVocab: true,
        perplexity: 2.7,
        cost: "0.17$",
        avg_latency: "800ms",
    },
    {
        key: 1,
        model: 'Llama 3 70B - Instruct',
        knowledge_cutoff: "2023-02-06-08:27:12",
        context_size: '8192',
        word2token: <div style={{ ...word2tokenStyle, color: colors.green }}>1:1.47</div>,
        isInVocab: false,
        perplexity: 3.5,
        cost: "2.1$",
        avg_latency: "1500ms",
    },
    {
        key: 2,
        model: "Mistral 7B - Instruct",
        knowledge_cutoff: "2023-02-06-08:27:12",
        context_size: '8192',
        word2token: <div style={{ ...word2tokenStyle, color: colors.green }}>1:1.49</div>,
        isInVocab: false,
        perplexity: 1.8,
        cost: "0.15$",
        avg_latency: "750ms",
    },
    {
        key: 3,
        model: "Mixtral 8X7B - Instruct",
        knowledge_cutoff: "2023-02-06-08:27:12",
        context_size: '8192',
        word2token: <div style={{ ...word2tokenStyle, color: colors.green }}>1:1.51</div>,
        isInVocab: true,
        perplexity: 3.2,
        cost: "0.7$",
        avg_latency: "900ms",
    },
]